import { Form } from "@/components/form/form";
import { FormField } from "@/components/form/form-field/form-field";
import { OrganizationAccessLevelSelectFormField } from "@/components/form/form-field/select/organization-access-level-select-form-field";
import { OrganizationAdmissionTypeSelectFormField } from "@/components/form/form-field/select/organization-admission-type-select-form-field";
import { Card, CardHeader, CardTitle, CardContent } from "@/components/ui/card";
import { IconButton } from "@/components/ui/icon-button";
import { OrganizationAccessLevel, OrganizationAdmissionType, type CreateOrganizationDTO } from "@/orval/model";
import { useOrganizationCreateOrganization } from "@/orval/organization";
import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { PlusIcon } from "lucide-react";

const defaultValues: CreateOrganizationDTO = {
  name: "",
  accessLevel: OrganizationAccessLevel.PUBLIC,
  admissionType: OrganizationAdmissionType.AUTOMATIC,
  isSiteEnabled: false,
  timeZoneId: "America/Chicago",
};

const CreateOrganizationPage: React.FC = () => {
  const { mutateAsync: createOrganization } = useOrganizationCreateOrganization();
  const navigate = useNavigate();

  const onSubmit = async (data: CreateOrganizationDTO) => {
    const newOrganization = await createOrganization({ data });

    if (newOrganization.id) {
      navigate({ to: "/organizations/$organizationId", params: { organizationId: newOrganization.id } });
    }
  };

  return (
    <div className="flex items-center justify-center h-full">
      <Card className="max-w-full w-96">
        <CardHeader>
          <CardTitle>Create Organization</CardTitle>
        </CardHeader>
        <CardContent>
          <Form<CreateOrganizationDTO> onSubmit={onSubmit} useFormProps={{ defaultValues }}>
            <FormField
              label="Name"
              name="name"
              inputProps={{ placeholder: "Your organization's name", autoFocus: true }}
              rules={{ required: true }}
            />

            <OrganizationAccessLevelSelectFormField name="accessLevel" label="Access Level" />

            <OrganizationAdmissionTypeSelectFormField name="admissionType" label="Admission Type" />

            <IconButton type="submit" icon={<PlusIcon />} className="w-full">
              Create Organization
            </IconButton>
          </Form>
        </CardContent>
      </Card>
    </div>
  );
};

export const Route = createFileRoute("/_app/organizations/new")({
  component: CreateOrganizationPage,
});
